import { TFunction } from '@gem/modules/i18n';

import {
  TSystemMessageTextHandler,
  ISystemMessageText,
  ISystemMessageTextPresenter,
} from '../useSystemMessageText.types';

export const chatOwnerChangedHandler: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  const result: ISystemMessageText = { html: '' };

  result.html = t('group_chat_ownership_was_transfered', {
    0: `<span class="system-message-title">${presenter.initiatorDisplayName}</span>`,
    1: `<span class="system-message-title">${presenter.firstUserDisplayedName}</span>`,
    interpolation: { escapeValue: false },
  });
  result.sourceText = t('group_chat_ownership_was_transfered');
  result.params = {
    '{0}': { text: presenter.initiatorDisplayName, userId: presenter.initiator?.id },
    '{1}': { text: presenter.firstUserDisplayedName, userId: presenter.firstUserId },
  };

  return result;
};
